import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

// import Custom Components
import Breadcrumb from "../../common/breadcrumb";
import ProfileOne from "../../features/profile/profile-one";
import OwlCarousels from "../../features/owl-carousel";
import Testimonial from "../../features/testimonial";

// import Utils
import { mainSlider5 } from "../../settings";

import _data from "../../../mock_data/data.json";

function AboutOne() {
  useEffect(() => {
    const handleScrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };
    handleScrollToTop();
    document.querySelector(".footer-middle") &&
      document.querySelector(".footer-middle").classList.add("border-0");
  }, []);

  return (
    <div className="main">
      <Helmet>
        <title>LIBER - About </title>
      </Helmet>

      <h1 className="d-none">LIBER - About </h1>

      <Breadcrumb
        title="About Us"
        parent1={["Pages", "pages/about"]}
        adClass="border-0 mb-0"
      />

      <div className="container">
        <div
          className="page-header page-header-big text-center"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/about-header-bg.jpg)`,
          }}
        >
          <h1 className="page-title text-white">
            About us<span className="text-white">Who we are</span>
          </h1>
        </div>
      </div>

      <div className="page-content pb-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 mb-3 mb-lg-0">
              <h2 className="title">Our Vision</h2>
              <p>
                Your search for a stylish holiday wardrobe ends here. Our
                holiday shop has everything you need to take the stress out of
                shopping for the season. You'll find holiday fashion perfect for
                the beach, shorts, jumpsuits & playsuits, bikinis, swimsuits,
                cover-ups, kaftans, flip flops, summer bags, beach bags, hats,
                swimming goggles, floats & toys, & sunglasses.
              </p>
            </div>

            <div className="col-lg-6">
              <h2 className="title">Our Mission</h2>
              <p>
                The LIBER has started with a simple dream: we wanted to change
                the way India approached the water. To swim for health, visit
                the beach for leisure, and to do so fashionably, safely and
                happily with the company of friends and family. Today, The LIBER
                has shipped over 10k units and we have over on offer for you and
                your family
              </p>
            </div>
          </div>

          <div className="mb-5"></div>
        </div>

        <div className="bg-light-2 pt-6 pb-5 mb-6 mb-lg-8">
          <div className="container">
            <div className="row">
              <div className="col-lg-5 mb-3 mb-lg-0">
                <h2 className="title">
                  Thank you for being a part of this dream with us.
                </h2>
                <p className="lead text-primary mb-3">
                  Liber Welcomes You Always
                </p>
                <p className="mb-2">Enjoy Shopping with Us</p>

                <Link
                  to={`/`}
                  className="btn btn-sm btn-minwidth btn-outline-primary-2"
                >
                  <span>VIEW OUR PRODUCTS</span>
                  <i className="icon-long-arrow-right"></i>
                </Link>
              </div>

              <div className="col-lg-6 offset-lg-1">
                <div className="about-images">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/about/img-1.jpg`}
                    alt=""
                    className="about-img-front"
                  />
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/about/img-2.jpg`}
                    alt=""
                    className="about-img-back"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="brands-text">
                <h2 className="title">
                  The world's premium brands in one destination.
                </h2>
                <p>LIBER Welcomes You Always !</p>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="brands-display">
                <div className="row justify-content-center">
                  {_data.brands.default.map((brand, index) => (
                    <div className="col-6 col-sm-4" key={index}>
                      <Link to="#" className="brand">
                        <img
                          src={process.env.PUBLIC_URL + "/" + brand.image}
                          alt="Brand Name"
                        />
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <hr className="mt-4 mb-6" />

          <h2 className="title text-center mb-4">Meet Our Team</h2>

          <div className="row">
            <div className="col-md-4">
              <ProfileOne
                image={`assets/images/team/member-1.jpg`}
                name="Samanta Grey"
                title="Founder & CEO"
                content="Sed pretium, ligula sollicitudin viverra, tortor libero sodales leo, eget blandit nunc."
              />
            </div>
            <div className="col-md-4">
              <ProfileOne
                image={`assets/images/team/member-2.jpg`}
                name="Bruce Sutton"
                title="Sales & Marketing Manager"
                content="Sed pretium, ligula sollicitudin viverra, tortor libero sodales leo, eget blandit nunc."
              />
            </div>
            <div className="col-md-4">
              <ProfileOne
                image={`assets/images/team/member-3.jpg`}
                name="Janet Joy"
                title="Product Manager"
                content="Sed pretium, ligula sollicitudin viverra, tortor libero sodales leo, eget blandit nunc."
              />
            </div>
          </div>
        </div>

        <div className="mb-2"></div>

        <div className="about-testimonials bg-light-2 pt-6 pb-6">
          <div className="container">
            <h2 className="title text-center mb-3">
              What Customer Say About Us
            </h2>

            <OwlCarousels
              adClass="owl-simple owl-testimonials-photo"
              carouselOptions={mainSlider5}
            >
              <Testimonial
                image={`assets/images/testimonials/user-1.jpg`}
                content="“Your swimsuit exceeded my expectations! The quality is exceptional, and the fit is perfect.</br> I received so many compliments when I wore it, and I felt confident and stylish all day long.</br> Thank you for providing such amazing swimwear!”"
                name="Jenson Gregory"
                job="Customer"
              />

              <Testimonial
                image={`assets/images/testimonials/user-2.jpg`}
                content="“I absolutely love the swimsuit I purchased from your store!</br>  The design is trendy and flattering and the fabric feels comfortable against my skin.</br> I can't wait to wear it to the beach! ”"
                name="Victoria Ventura"
                job="Customer"
              />
            </OwlCarousels>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(AboutOne);
